import { render } from "./ResetPasswordPhone.vue?vue&type=template&id=850ed584&scoped=true"
import script from "./ResetPasswordPhone.vue?vue&type=script&lang=js"
export * from "./ResetPasswordPhone.vue?vue&type=script&lang=js"

import "./ResetPasswordPhone.vue?vue&type=style&index=0&id=850ed584&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-850ed584"]])

export default __exports__